<template>
  <section slot="body">
    <div class="modal-body">
      <form action="" class="m-form m-form--state">
        <div  class="m-portlet__body">
          <div class="m-form__group form-group" :class="{'has-danger': errors.has('property')}">
            <label>{{'property' | translate | capitalize}}</label>
            <select  v-validate="'required'" v-model="property" name="property" class="form-control m-input" >
              <option value="">
                {{'select_property' | translate | capitalize}}
              </option>
              <option v-for="(property,index) in properties" :key="index" :value="index">
                {{property.prop.value | translate | capitalize}}
              </option>                    
            </select>
            <span v-show="errors.has('property')" class="m-form__help m--font-danger">{{ errors.first('property') }}</span>                                       
          </div>
          <div class="m-form__group form-group" :class="{'has-danger': errors.has('plan')}">
            <label>{{'plan' | translate | capitalize}}</label>
            <select  v-validate="'required'" v-model="plan" name="plan" class="form-control m-input" >
              <option value="">
                {{'select_plan' | translate | capitalize}}
              </option>                
              <option v-for="option in configs.option" :key="option.key" :value="option.name">
                {{option.key | translate | capitalize}}
              </option>                    
            </select>
            <span v-show="errors.has('plan')" class="m-form__help m--font-danger">{{ errors.first('plan') }}</span>  
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button"  class="btn btn-secondary" data-dismiss="modal" @click="back()">
        {{'cancel' | translate | capitalize}}
      </button>
      <button type="submit" class="btn btn-primary" @click="validateForm">
        {{'assign' | translate | capitalize}}
      </button>
    </div>
  </section>
</template>
<script>
import SModal from '@/components/layout/modal/Modal.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
  components: { SModal },
  data () {
    return {
      properties: [],
      property: '',
      configs: [],
      plan: ''
    }
  },
  computed: {
    ...mapGetters({modal: 'getStatusSupModal'})
  },
  methods: {
    ...mapActions(['getPlans', 'editPlans']),
    back () {
      this.plan = ''
      this.property = ''
      this.$validator.reset()
    },
    validateForm () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$spinner.show()
          this.editPlans({id: this.configs.id, shard: this.properties[this.property].shard, plan: this.plan}).then((result) => {
            this.$spinner.remove()
            if (result.data.status === 200) {
              window.$('#property_plan').modal('toggle')
              this.$toast('edit_plan_message')
              this.$router.push({name: 'suport'})
            } else {
              this.$toast('edit_plan_error', 4)
            }
          })
        }
      })
    }
  },
  created () {
    this.getPlans().then((result) => {
      if (result.data.status === 200) {
        this.properties = result.data.content.properties
        this.configs = result.data.content.config
      }
    })
  },
  watch: {
    modal () {
      this.$validator.reset()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Plan.vue